export const AUTH_TOKEN = '@recurrence-auth-token'
export const PROJECT_TAG = 'recorrencia'